
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../layouts';
import { useDashboard } from '../hooks/useDashboard';
import { ISession } from '@bemap/utils';
import { FC } from 'react';

interface DashboardProps {
  children: React.ReactNode;
  user: ISession | null;
  hideTopbarTabs?: boolean;
  appVersion?: string;
}

export const Dashboard: FC<DashboardProps> = ({ children, user, hideTopbarTabs = false, appVersion = '0.0.0' }) => {
  const navigate = useNavigate();
  const { topbarTabs, activeSubsystem, currentSidebarLinks } = useDashboard(user);

  const topbarTabsWithNavigation = topbarTabs.map(tab => ({
    ...tab,
    onClick: () => navigate(tab.href),
  }));

  return (
    <DashboardLayout
      user={user}
      sidebarLinks={currentSidebarLinks}
      topbarTabs={hideTopbarTabs ? [] : topbarTabsWithNavigation}
      activeSubsystem={activeSubsystem}
      appVersion={appVersion}
    >
      {children}
    </DashboardLayout>
  );
}; 